import React from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Box,
  Typography,
  Button,
} from '@mui/material';

interface ConfirmationDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  itemType: 'field' | 'setting';
  itemName?: string;
}

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  open,
  onClose,
  onConfirm,
  itemType,
  itemName,
}) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <Box sx={{ p: 2, pb: 0 }}>
        <Typography variant='h6' id='alert-dialog-title'>
          {`Confirm Delete ${itemType === 'setting' ? 'Setting' : 'Field'}`}
        </Typography>
      </Box>
      <DialogContent>
        <DialogContentText id='alert-dialog-description'>
          {itemType === 'setting'
            ? `Are you sure you want to delete the setting "${itemName}"? This will also delete all fields within this setting.`
            : `Are you sure you want to delete the field "${itemName}"?`}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color='primary'>
          Cancel
        </Button>
        <Button onClick={onConfirm} color='primary' autoFocus>
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
